const activities = {
    cantina_tilli: {
        name: 'Tilli Estate',
        subtitle: 'Wine Tasting and Typical Products',
        description: 'Visit the Tilli Estate for a tasting of local wines and typical products from Abruzzo. An authentic experience to discover the traditional flavors of the region.',
        duration: '2-3 hours',
        difficulty: 'Beginner',
        season: 'All year round',
        price: '€25-45',
        locations: [
            'Scanno',
            'Villetta Barrea'
        ],
        requirements: [
            'Minimum age: 18 years for wine tasting',
            'Booking required',
            'Casual attire'
        ],
        included: [
            'Wine tasting',
            'Local typical products',
            'Guided tour of the winery',
            'Insurance'
        ],
        highlights: [
            'Quality local wines',
            'Typical Abruzzo products',
            'Visit to historic winery',
            'Authentic experience',
            'Purchase possibility'
        ]
    },
    arrosticini_mucciante: {
        name: 'Arrosticini at Mucciante',
        subtitle: 'Authentic Abruzzo Culinary Tradition',
        description: 'Experience the authentic taste of Abruzzo arrosticini at the historic Mucciante restaurant. A traditional culinary experience that will introduce you to the most authentic flavors of the region.',
        duration: '1-2 hours',
        difficulty: 'Beginner',
        season: 'All year round',
        price: '€15-25',
        locations: [
            'Mucciante',
            'Rocca Calascio area'
        ],
        requirements: [
            'Booking recommended',
            'Casual attire'
        ],
        included: [
            'Traditional arrosticini',
            'Local wine',
            'Traditional sides',
            'Authentic atmosphere'
        ],
        highlights: [
            'Historic restaurant',
            'Traditional preparation',
            'Authentic Abruzzo flavors',
            'Pairing with local wine',
            'Cultural experience'
        ]
    },
    sextantio: {
        name: 'Overnight Stay at Sextantio Hotel',
        subtitle: 'The Scattered Hotel of the Village',
        description: 'Stay at the unique Sextantio Hotel, a scattered hotel that preserves the authentic architecture of Santo Stefano di Sessanio. An unforgettable experience immersed in history and tradition.',
        duration: 'Overnight',
        difficulty: 'Beginner',
        season: 'All year round',
        price: '€150-300 per night',
        locations: [
            'Santo Stefano di Sessanio'
        ],
        requirements: [
            'Booking required',
            'Valid ID'
        ],
        included: [
            'Overnight stay',
            'Traditional breakfast',
            'Historic room',
            'Hotel services'
        ],
        highlights: [
            'Historic architecture',
            'Authentic atmosphere',
            'Traditional breakfast',
            'Unique experience',
            'Village location'
        ]
    },
    wild_life_spotting: {
        name: 'Wildlife',
        subtitle: 'Discover the wild nature of Abruzzo',
        description: 'Discovering deer and wolves',
        duration: '2 hours',
        difficulty: 'Easy'
    }
};

export default activities;
